/**
 *  When user click to item this function build transition url
 */
import { DependencyUsage } from '@modules/Dependencies/api/models/dependency-usage.model';
import { Dependency} from '@modules/Dependencies/api/models/dependency.model';
import { makeLinkSelfParams } from '../../../dependenciesSearch/src/utils/transitionLinkParamsBuilder';

export const getEntityTransitionUrl = {
    Workflow: (item: Dependency, usage?: DependencyUsage) => {
        let search = '';
        if(usage) {
            const linkParams = usage && makeLinkSelfParams(usage);
            const params = linkParams?.params;

            if(params) {
                if(params.uri) {
                    return params.uri;
                }

                type TKey = keyof NonNullable<typeof params>;
                const keys: TKey[] = (Object.keys(params) as TKey[]).filter(key => !(['uri'] as TKey[]).includes(key));

                const searchParams = keys
                    .map(key => params[key] !== undefined ? `${key}=${params[key]}` : '')
                    .filter(v => !!v)
                    .join('&');

                search = searchParams ? `?openView&${searchParams}` : '';
            }
        }

        return `#/workflows/edit/${item.Name}/${item.Version}${search}`;
    },
    DataContext: (item: Dependency, usage: DependencyUsage) => `#/prototypes/edit/${item.Name}`,
    DataProvider: (item: Dependency, usage: DependencyUsage) => `#/providers/edit/${item.Name}`,
    Model: (item: Dependency, usage: DependencyUsage) => `#/models/invoke/${item.Name}`,
    LocalFunction: (item: Dependency, usage: DependencyUsage) => `#/functions/details/${item.Name}`,
    Package: (item: Dependency, usage: DependencyUsage) => `#/functions/remote/browse/${item.Name}`,
    ParametersTable: (item: Dependency, usage: DependencyUsage) => `#/parametertable/edit/${item.Name}/${item.Version}`,
    Signal: (item: Dependency, usage: DependencyUsage) => `#/signals/edit/${item.Name}`,
    Component: (item: Dependency, usage: DependencyUsage) => {
        switch (item.EntitySubType) {
            case 'RemoteFunction': {
                return `#/components/package/${item.Name}`;
            }
            case 'LocalFunction': {
                return `#/components/package/${item.Name}`;
            }
            case 'Workflow': {
                return getEntityTransitionUrl.Workflow(item);
            }
        }
    }
};
